import(/* webpackMode: "eager" */ "/app/apps/reporting-maximizer/src/app/global-error.tsx");
